import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter, Route, Switch, Redirect } from 'react-router-dom'
import AdjustControl from './AdjustControl/AdjustControl'
import FiltersControl from './FiltersControl/FiltersControl'
import CropperControl from './CropperControl/CropperControl'
import ResizeControl from './ResizeControl/ResizeControl'
import RotateControl from './RotateControl/RotateControl'
import { removeLastSetting } from '../../store/actions/settings.actions'
import { getLatestSetting } from '../../helpers/util'

class Controls extends Component {
  static propTypes = {
    settingsList: PropTypes.array.isRequired,
    currentSettingId: PropTypes.number.isRequired,
    dispatchRemoveLastSetting: PropTypes.func.isRequired,
    imageSrc: PropTypes.string.isRequired,
    imageSrcUploaded: PropTypes.string.isRequired,
    isCanvasInited: PropTypes.bool.isRequired,
    location: PropTypes.object.isRequired,
    imageData: PropTypes.object,
  }

  componentDidUpdate(prevProps) {
    const {
      location,
      settingsList,
      currentSettingId,
      dispatchRemoveLastSetting
    } = this.props
    const latestSetting = getLatestSetting(settingsList)

    // if url changed or UNDO was clicked while there is an uncommitted setting,
    // remove that setting without any confirmation
    if (
      (location.pathname !== prevProps.location.pathname || currentSettingId < prevProps.currentSettingId) &&
      latestSetting && !latestSetting.isCommitted
    ) {
      dispatchRemoveLastSetting()
    }
  }

  render() {
    const {
      imageSrc,
      imageSrcUploaded,
      imageData,
      isCanvasInited
    } = this.props

    if (!(imageSrc || imageSrcUploaded)) {
      return (
        <Switch>
          <Route
            path="/"
            exact
            component={null}
          />
          <Redirect to="/" />
        </Switch>
      )
    }

    // For some controls it's enough to have only imageData inited,
    // for others canvas should be inited too (e.g. Cropper)
    if ((imageSrc || imageSrcUploaded) && (!imageData || !isCanvasInited)) {
      return <div className="controls" />
    }

    return (
      <div className="controls">
        <Switch>
          <Route
            path="/"
            exact
            component={AdjustControl}
          />
          <Route path="/filters" component={FiltersControl} />
          <Route path="/crop" component={CropperControl} />
          <Route path="/resize" component={ResizeControl} />
          <Route path="/rotate" component={RotateControl} />
          <Redirect to="/" />
        </Switch>
      </div>
    )
  }
}

const mapStateToProps = ({
  imageStore: {
    imageSrc,
    imageData,
    imageSrcUploaded
  },
  canvasStore: {
    isCanvasInited
  },
  settingsStore: {
    currentSettingId,
    settingsList
  },
}) => ({
  imageSrc,
  imageSrcUploaded,
  imageData,
  isCanvasInited,
  currentSettingId,
  settingsList
})

const mapDispatchToState = (dispatch) => ({
  dispatchRemoveLastSetting: (id) => dispatch(removeLastSetting(id)),
})


export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToState
  )(Controls)
)
